import {
    GET_INSPECTOR_FILTERS_REQUEST,
    GET_INSPECTOR_FILTERS_SUCCESS,
    GET_INSPECTOR_FILTERS_FAIL,
    EVALUATE_INSPECTORS_REQUEST,
    EVALUATE_INSPECTORS_SUCCESS,
    EVALUATE_INSPECTORS_FAIL,
    GET_SUPERVISOR_FILTERS_REQUEST,
    GET_SUPERVISOR_FILTERS_SUCCESS,
    GET_SUPERVISOR_FILTERS_FAIL,
    EVALUATE_SUPERVISORS_REQUEST,
    EVALUATE_SUPERVISORS_SUCCESS,
    EVALUATE_SUPERVISORS_FAIL,
    GET_MUNICIPALITY_FILTERS_REQUEST,
    GET_MUNICIPALITY_FILTERS_SUCCESS,
    GET_MUNICIPALITY_FILTERS_FAIL,
    EVALUATE_MUNICIPALITY_REQUEST,
    EVALUATE_MUNICIPALITY_SUCCESS,
    EVALUATE_MUNICIPALITY_FAIL,
  } from "../actions/evaluation";
  
  const initialState = {
    inspectorFilters: { loading: false, data: null, error: null },
    supervisorFilters: { loading: false, data: null, error: null },
    municipalityFilters: { loading: false, data: null, error: null },
    inspectorEvaluation: { loading: false, data: null, error: null },
    supervisorEvaluation: { loading: false, data: null, error: null },
    municipalityEvaluation: { loading: false, data: null, error: null },
  };
  
  export default function evaluation(state = initialState, action) {
    switch (action.type) {
      case GET_INSPECTOR_FILTERS_REQUEST:
        return {
          ...state,
          inspectorFilters: { ...state.inspectorFilters, loading: true, error: null },
        };
      case GET_INSPECTOR_FILTERS_SUCCESS:
        return {
          ...state,
          inspectorFilters: { loading: false, data: action.payload.data, error: null },
        };
      case GET_INSPECTOR_FILTERS_FAIL:
        return {
          ...state,
          inspectorFilters: { loading: false, data: null, error: action.payload.error },
        };
  
      case EVALUATE_INSPECTORS_REQUEST:
        return {
          ...state,
          inspectorEvaluation: { ...state.inspectorEvaluation, loading: true, error: null },
        };
      case EVALUATE_INSPECTORS_SUCCESS:
        return {
          ...state,
          inspectorEvaluation: { loading: false, data: action.payload.data, error: null },
        };
      case EVALUATE_INSPECTORS_FAIL:
        return {
          ...state,
          inspectorEvaluation: { loading: false, data: null, error: action.payload.error },
        };
  
      case GET_SUPERVISOR_FILTERS_REQUEST:
        return {
          ...state,
          supervisorFilters: { ...state.supervisorFilters, loading: true, error: null },
        };
      case GET_SUPERVISOR_FILTERS_SUCCESS:
        return {
          ...state,
          supervisorFilters: { loading: false, data: action.payload.data, error: null },
        };
      case GET_SUPERVISOR_FILTERS_FAIL:
        return {
          ...state,
          supervisorFilters: { loading: false, data: null, error: action.payload.error },
        };
  
      case EVALUATE_SUPERVISORS_REQUEST:
        return {
          ...state,
          supervisorEvaluation: { ...state.supervisorEvaluation, loading: true, error: null },
        };
      case EVALUATE_SUPERVISORS_SUCCESS:
        return {
          ...state,
          supervisorEvaluation: { loading: false, data: action.payload.data, error: null },
        };
      case EVALUATE_SUPERVISORS_FAIL:
        return {
          ...state,
          supervisorEvaluation: { loading: false, data: null, error: action.payload.error },
        };
  
      case GET_MUNICIPALITY_FILTERS_REQUEST:
        return {
          ...state,
          municipalityFilters: { ...state.municipalityFilters, loading: true, error: null },
        };
      case GET_MUNICIPALITY_FILTERS_SUCCESS:
        return {
          ...state,
          municipalityFilters: { loading: false, data: action.payload.data, error: null },
        };
      case GET_MUNICIPALITY_FILTERS_FAIL:
        return {
          ...state,
          municipalityFilters: { loading: false, data: null, error: action.payload.error },
        };
  
      case EVALUATE_MUNICIPALITY_REQUEST:
        return {
          ...state,
          municipalityEvaluation: { ...state.municipalityEvaluation, loading: true, error: null },
        };
      case EVALUATE_MUNICIPALITY_SUCCESS:
        return {
          ...state,
          municipalityEvaluation: { loading: false, data: action.payload.data, error: null },
        };
      case EVALUATE_MUNICIPALITY_FAIL:
        return {
          ...state,
          municipalityEvaluation: { loading: false, data: null, error: action.payload.error },
        };
  
      default:
        return state;
    }
  }
  